<template>
    <div id="data-personal-tecnico-list-view">
        <vx-card class="mb-base" no-shadow card-border>
            <div class="flex items-end mb-2">
                <feather-icon icon="UsersIcon" class="mr-2" svgClasses="w-5 h-5" />
                <span class="font-medium leading-none">Personal Técnico de los Proyectos de Inversion</span>
            </div>

            <vs-divider/>

            <div class="vx-row">
                <div class="w-full mb-4 vx-col md:w-2/3">
                    <div class="vx-row">
                        <div class="w-full mb-4 vx-col md:w-2/3">
                            <label class="text-sm font-bold opacity-100">Area o Gerencia/SubGerencia</label>
                            <v-select :options="itemsOficina" v-model="selectedOficina" :clearable="false" :dir="$vs.rtl ? 'rtl' : 'ltr'" class="mb-4 md:mb-0" name="producto">
                                <template v-slot:no-options="{ searching }">
                                    <template v-if="searching">
                                        No se encontraron resultados
                                    </template>
                                    <span v-else style="opacity: 0.5">No existen resultados</span>
                                </template>
                            </v-select>
                            <span class="text-sm text-danger" v-show="errors.has('area')">{{ errors.first('area') }}</span>
                        </div>
                        <div class="w-full mb-4 vx-col md:w-1/3">
                            <label class="ml-2 text-sm font-bold opacity-100">Fecha</label>
                            <datepicker :disabledDates="disabledDatesInicio" :language="es" v-model="inputFecha" format="dd/MM/yyyy" v-validate="'required'" name="fecha"></datepicker>
                            <span class="text-sm text-danger" v-show="errors.has('fecha')">{{ errors.first('fecha') }}</span>
                        </div>
                    </div>
                </div>
                
                <div class="w-full mb-4 vx-col md:w-1/3">
                    <div class="flex flex-wrap items-start justify-start">
                        <vs-button @click="buscarPorFecha" icon-pack="feather" color="primary" icon="icon-search" class="mt-6">Buscar</vs-button>
                    </div>
                </div>
            </div>

            <vs-table stripe ref="table" :data="itemsPersonal" pagination :max-items="itemsPerPage" search noDataText="No existen datos">
                <div slot="header" class="flex flex-wrap-reverse items-center justify-between flex-grow">
                    <vs-dropdown vs-trigger-click class="mb-4 mr-4 cursor-pointer items-per-page-handler">
                        <div class="flex items-center justify-between p-4 font-medium border border-solid rounded-full cursor-pointer d-theme-border-grey-light d-theme-dark-bg">
                            <span class="mr-2">{{ currentPage * itemsPerPage - (itemsPerPage - 1) }} - {{ itemsPersonal.length - currentPage * itemsPerPage > 0 ? currentPage * itemsPerPage : itemsPersonal.length }} de {{ itemsPersonal.length }}</span>
                            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
                        </div>
                        
                        <vs-dropdown-menu>
                            <vs-dropdown-item @click="itemsPerPage=5">
                            <span>5</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item @click="itemsPerPage=10">
                            <span>10</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item @click="itemsPerPage=25">
                            <span>25</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item @click="itemsPerPage=50">
                            <span>50</span>
                            </vs-dropdown-item>
                        </vs-dropdown-menu>
                    </vs-dropdown>
                </div>
                <template slot="thead">
                    <vs-th>DNI</vs-th>
                    <vs-th>NOMBRES</vs-th>
                    <vs-th>CARGO</vs-th>
                    <vs-th>META</vs-th>
                    <vs-th>INGRESO</vs-th>
                    <vs-th>SALIDA</vs-th>
                    <vs-th>SEMAFORO</vs-th>
                    <vs-th>ACCIONES</vs-th>
                </template>
                <template slot-scope="{data}">
                    <tbody>
                        <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                            <vs-td :data="data[indextr].dni">
                                {{ data[indextr].dni }}
                            </vs-td>
                            <vs-td :data="data[indextr].nombres">
                                <span class="text-black text-bold">{{ data[indextr].nombres }}</span>
                            </vs-td>
                            <vs-td :data="data[indextr].cargo">
                                <span class="text-black text-bold">{{ data[indextr].cargo }}</span>
                            </vs-td>
                            <vs-td :data="data[indextr].meta">
                                {{ data[indextr].meta }}
                            </vs-td>
                            <vs-td :data="data[indextr].ingreso">
                                {{ data[indextr].ingreso }}
                            </vs-td>
                            <vs-td :data="data[indextr].salida">
                                {{ data[indextr].salida }}
                            </vs-td>
                            <vs-td :data="data[indextr].semaforo">
                                <feather-icon icon="CircleIcon" :svgClasses="['fill-current h-6 w-6', textColor(data[indextr].semaforo)]" />
                            </vs-td>
                            <vs-td :data="data[indextr].meta" class="whitespace-no-wrap">
                                <div class="vx-row-actions">
                                    <vx-tooltip text="Notificar por correo" position="bottom">
                                        <vs-button @click="enviar(tr)" class="ml-2" color="warning" type="filled" icon-pack="feather" icon="icon-mail" size="small"></vs-button>
                                    </vx-tooltip>
                                    <vx-tooltip text="Ver registros" position="bottom">
                                        <vs-button @click="detalle(tr)" class="ml-2" color="success" type="filled" icon-pack="feather" icon="icon-search" size="small"></vs-button>
                                    </vx-tooltip>
                                </div>
                            </vs-td>
                        </vs-tr>
                    </tbody>
                </template>
            </vs-table>

            <div class="flex flex-wrap-reverse items-center justify-end flex-grow">
                <p class="text-sm truncate">
                    Mostrando registros del <strong>{{ currentPage * itemsPerPage - (itemsPerPage - 1) }}</strong> al <strong>{{ itemsPersonal.length - currentPage * itemsPerPage > 0 ? currentPage * itemsPerPage : itemsPersonal.length }}</strong> de un total de <strong>{{ itemsPersonal.length }}</strong> registros
                </p>
            </div>
        </vx-card>

        <vs-popup title="Registro de actividades" :active.sync="popupRegistros" id="data-personal-tecnico-list-view">
            <vs-table stripe ref="table" :data="itemsRegistros" pagination max-items="10" noDataText="No existen datos">
                <template slot="thead">
                    <vs-th>META</vs-th>
                    <vs-th>FECHA</vs-th>
                    <vs-th>DESCRPCION</vs-th>
                    <vs-th>LATITUD</vs-th>
                    <vs-th>LONGITUD</vs-th>
                </template>
                <template slot-scope="{data}">
                    <tbody>
                        <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                            <vs-td :data="data[indextr].fechaRegistro">
                                {{ data[indextr].actividad.meta }}
                            </vs-td>
                            <vs-td :data="data[indextr].fechaRegistro">
                                {{ data[indextr].fechaRegistro }}
                            </vs-td>
                            <vs-td :data="data[indextr].descripcion">
                                <span class="text-black text-bold">{{ data[indextr].descripcion }}</span>
                            </vs-td>
                            <vs-td :data="data[indextr].latitud">
                                {{ data[indextr].latitud }}
                            </vs-td>
                            <vs-td :data="data[indextr].longitud">
                                {{ data[indextr].longitud }}
                            </vs-td>
                        </vs-tr>
                    </tbody>
                </template>
            </vs-table>

            <div class="w-full vx-col">
                <div class="flex flex-wrap items-center justify-end">
                    <vs-button @click="aceptar" icon-pack="feather" color="primary" icon="icon-check" class="mt-2 ml-auto">Aceptar</vs-button>    
                </div>
            </div>

        </vs-popup>

    </div>
</template>
<script>
import vSelect from 'vue-select';
import Datepicker from 'vuejs-datepicker';
import { es } from 'vuejs-datepicker/src/locale';
export default {
    components: {
        vSelect,
        Datepicker,
    },

    data(){
        return {
            es: es,
            selectedOficina     : null,
            itemsOficina        : [],
            itemsPersonal       : [],
            itemsPerPage        : 10,
            isMounted           : false,

            inputFecha          : new Date(),
            disabledDatesInicio : {
                to: new Date(new Date().getFullYear(), new Date().getMonth() - 2, new Date().getDate()),
                from: new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate()),
            },

            ndocumento          : null,

            popupRegistros      : false,
            itemsRegistros      : []
        }
    },

    computed: {
        currentPage () {
            if (this.isMounted) {
                return this.$refs.table.currentx;
            }
            return 0;
        },
    },

    created(){
        //this.getOficina();
    },

    mounted () {
        this.isMounted = true;
    },

    watch: {
        selectedOficina(val){
            if(val !== null){
                this.buscarPorFecha();
            }
        }
    },

    methods: {
        ////////////////temporal///////////////////////////////
        procesar(){
            let dayFin = `${(this.inputFecha.getDate())}`.padStart(2,'0');
            let monthFin = `${(this.inputFecha.getMonth()+1)}`.padStart(2,'0');
            let yearFin = this.inputFecha.getFullYear();

            const fecha = `${ dayFin }-${ monthFin }-${ yearFin }`;
            this.$vs.loading();
            this.$http.procesarAsistencia(fecha)
            .then(response => {
                this.$vs.loading.close();
                this.$vs.dialog({
                    type: 'alert',
                    color: 'success',
                    title: `Aviso`,
                    text: response.data,
                    acceptText: 'Aceptar',
                });
                return;
            }).catch(error => {
                this.$vs.loading.close();
                this.showMessageError(error.response.status, error.response.data.message);
            });
        },


        getOficina(){
            this.$vs.loading();
            this.$http.listOficinaActivo()
            .then(response => {
                this.$vs.loading.close();
                if(response.status === 200){
                    this.itemsOficina = response.data;
                    this.selectedOficina = response.data[0];
                }
            }).catch(error => {
                this.$vs.loading.close();
                this.showMessageError(error.response.status, error.response.data.message);
            });
        },

        buscarPorFecha(){
            let dayFin = `${(this.inputFecha.getDate())}`.padStart(2,'0');
            let monthFin = `${(this.inputFecha.getMonth()+1)}`.padStart(2,'0');
            let yearFin = this.inputFecha.getFullYear();

            const fecha = `${ dayFin }-${ monthFin }-${ yearFin }`;
            const payload = {
                id: this.selectedOficina.value,
                data: fecha
            };

            this.$vs.loading();
            this.$http.semaforoPorPersonal(payload)
            .then(response => {
                this.$vs.loading.close();
                if(response.status === 200){
                    this.itemsPersonal = response.data;
                }
            }).catch(error => {
                this.$vs.loading.close();
                this.showMessageError(error.response.status, error.response.data.message);
            });
        },

        notificar(tr){
            console.log(tr);
        },

        enviar(tr){
            this.ndocumento = tr.dni;
            this.$vs.dialog({
                type: 'confirm',
                color: 'danger',
                title: `Confirmación`,
                text: '¿Esta seguro de enviar el correo?',
                acceptText: 'Aceptar',
                cancelText: 'Cancelar',
                accept: this.enviarCorreo
            });
        },

        enviarCorreo(){
            if(this.ndocumento !== null){
                this.$http.enviarMailPorPersonal(this.ndocumento)
                .then(response => {
                    this.$vs.loading.close();
                    console.log(response);
                }).catch(error => {
                    this.$vs.loading.close();
                    this.showMessageError(error.response.status, error.response.data.message);
                });
            }
        },

        detalle(tr){
            if(tr.registros.length === 0){
                this.$vs.dialog({
                    type: 'alert',
                    color: 'danger',
                    title: `Aviso`,
                    text: 'No existen reporte diario de actividades.',
                    acceptText: 'Aceptar',
                });
                return;
            }
            this.itemsRegistros = tr.registros;
            this.popupRegistros = true;
        },

        aceptar(){
            this.popupRegistros = false;
        },

        textColor (value) {
            if(value === 1) return 'text-success';
            if(value === 2) return 'text-warning';
            if(value === 3) return 'text-primary';
            if(value === 4) return 'text-grey';
        },

        showMessageAlert(message){
            this.$vs.notify({
                title: 'Aviso',
                text: message,
                position:'top-center',
                iconPack: 'feather',
                icon: 'icon-alert-circle',
                color: 'danger'
            });
        },

        showMessageSuccess(message){
            this.$vs.notify({
                title: 'Información',
                text: message,
                position:'top-right',
                iconPack: 'feather',
                icon: 'icon-check',
                color: 'success'
            });
        },

        showMessageError(status, message){
            if(status === 400 || status === 409){
                this.$vs.notify({
                    title: 'Aviso',
                    text: message,
                    position:'top-center',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'warning'
                });
            }
            if(status === 401){
                this.popupRiesgo = false;
                this.popupEliminar = false;
                this.$store.dispatch("logout").then(() => {
                    this.$router.push('/login').catch(() => {})
                });
            }
            if(status === 403){
                this.popupRiesgo = false;
                this.popupEliminar = false;
                this.$vs.notify({
                    title: 'ACCESO DENEGADO',
                    text: 'No tiene permisos para esta proceso.',
                    position:'top-center',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            }
            if(status === 404){
                this.$vs.notify({
                    title: 'Aviso',
                    text: message,
                    position:'top-center',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'warning'
                });
            }
            if(status === 417){
                this.$vs.notify({
                    title: 'ALERTA',
                    text: message,
                    position:'top-center',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            }

            if(status === 500){
                this.$vs.notify({
                    title: 'ERROR',
                    text: 'Ups!!!. Ocurrio un error. Vuelve a intentarlo.',
                    position:'top-center',
                    iconPack: 'feather',
                    icon: 'icon-alert-triangle',
                    color: 'danger'
                });
            }
        },
    }

}
</script>
<style lang="scss">
#data-personal-tecnico-list-view {
.vs-con-table {
    @media (max-width: 689px) {
        .vs-table--search {
            margin-left: 0;
            max-width: unset;
            width: 100%;

            .vs-table--search-input {
                width: 100%;
            }
        }
    }

    @media (max-width: 461px) {
        .items-per-page-handler {
            display: none;
        }
    }

    @media (max-width: 341px) {
        .data-list-btn-container {
            width: 100%;

            .dd-actions,
            .btn-add-new {
                width: 100%;
                margin-right: 0 !important;
            }
        }
    }

    .vs-table--header {
        display: flex;
        flex-wrap: wrap;
        margin-left: 0.0rem;
        margin-right: 0.0rem;
        > span {
            display: flex;
            flex-grow: 1;
        }

        .vs-table--search{
            padding-top: 0;

            .vs-table--search-input {
                padding: 1.0rem 2.5rem;
                font-size: 1rem;

                &+i {
                    left: 1rem;
                }

                &:focus+i {
                    left: 1rem;
                }
            }
        }
    }

    .vs-table {
        font-size: 0.88rem;
        font-weight: 400;
        tr {
            box-shadow: 0 4px 20px 0 rgba(0,0,0,.05);
            td {
                padding: 10;
            }
            td.td-check {
               padding: 20px !important;
            }
        }
    }

    .vs-table--thead{
        th {
            padding: 10;
            background: #d9d8d8;
      
            &:first-child{
                border-top-left-radius: .3rem;
                border-bottom-left-radius: .3rem;
            }
            &:last-child{
                border-top-right-radius: .3rem;
                border-bottom-right-radius: .3rem;
            }
            .vs-table-text{
                text-transform: uppercase;
                font-weight: 600;
            }
        }
        th.td-check{
            padding: 0 15px !important;
        }
        tr{
            background: none;
            box-shadow: none;
        }
    }

    .vs-table--pagination {
        justify-content: center;
    }
  }
}

.vx-row-actions {
  display: flex;
  flex-wrap: nowrap;
  margin: 0 -1rem;

  & > .vx-col {
    padding: 0 1rem;
  }

  &.match-height>.vx-col {
    display: flex;
  }

  &.no-gutter {
    margin: 0;

    & > .vx-col {
      padding: 0;
    }
  }
}
</style>